import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { User} from '../../../classes/user';
import { CustomValidators} from '../../../validators/custom-validators';
import { Router} from '@angular/router';
import { BaseService } from '../../../services/base.service';
import { PopupService } from '../../../services/popup.service';
import { UserService } from '../../../services/user.service';
import { Subject } from "rxjs";

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit {

  inputChangeListener: Subject<any> = new Subject<any>();

  constructor(public formBuilder: FormBuilder, public popupService: PopupService,
              public userService: UserService, public router: Router, public baseService: BaseService, public ref: ChangeDetectorRef) {
    this.inputChangeListener
      .subscribe((data)=> {
        this.ref.detectChanges();
      });
  }

  forgotPasswordForm: FormGroup;
  user = new User();
  sent: boolean = false;
  enterMail: boolean = true;
  isSending: boolean = false;
  submitted: boolean = false;

  ngOnInit() {
    this.forgotPasswordForm = this.formBuilder.group({
      emailAddress: [this.user.emailAddress, Validators.compose([Validators.required, CustomValidators.email])]
    });
  }

  onSubmit() {
    this.submitted = true;
    this.ref.detectChanges();
    if(this.forgotPasswordForm.valid) {
      this.isSending = true;
      this.userService.forgotPassword(this.user).subscribe((result) => {
        if (result) {
          this.isSending = false;
          this.userService.setEmailAddress(this.user.emailAddress);
          this.sent = true;
          this.enterMail = false;
          this.ref.detectChanges();
        }
      },(error)=>{
        this.isSending = false;
      });
    }
  }

  closeModal() {
    this.submitted = false;
    this.forgotPasswordForm.reset();
    this.resetForgotPasswordState();
    this.popupService.updateRoute();
  }

  resetForgotPasswordState() {
    this.sent = false;
    this.enterMail = true;
    this.user.emailAddress = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/components/password-recovery/forgot-password/forgot-password.component.ts